import { useMutation } from "react-query";
import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { Branch } from "../Branch";
import { branchUrls } from "../../URL/ApplicationUrls";
import { updateSuccessMessage } from "../../Messages/successMessages";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import { combinedUrls } from "../../URL/functions";

export const useUpdateBranch = () => {
  return useMutation({
    mutationFn: (branch: Branch) =>
      axios.put<Branch>(
        combinedUrls(branchUrls.branchesForCarrierWithId(branch.CarrierId), branch.Id.toString()),
        branch
      ),
    onSuccess: async (response: AxiosResponse<Branch>) => {
      toast.success(updateSuccessMessage(response.data.Id, "Branch"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
